import React, { useMemo } from 'react';

import DetailsProducts from './DetailsProducts/DetailsProducts';
import DetailsProductsActions from './DetailsProducts/DetailsProductsActions/DetailsProductsActions';
import { DataDetailsOrder, DataDetailledOrder } from 'types/DetailsProducts';

function OrderDetails({ order }: { order: DataDetailsOrder }): JSX.Element {
  const orderArticles = useMemo(() => {
    const orderArticles = order.ARTICLES.ARTICLE;

    return orderArticles.length > 0 ? orderArticles : [orderArticles];
  }, [order.ARTICLES.ARTICLE]);

  const products = useMemo(() => {
    const products = orderArticles.length > 0 ? orderArticles : [orderArticles];
    return products.map(product => ({
      refCatalog: product.REF_CATALOG,
      libelle: product.DESIGNATION.toLowerCase(),
      productPrice: product.PU_TTC,
      quantity: product.QTE,
      discount: product.REMISE,
      subTotalProduct: (
        parseFloat(product.PU_TTC) * parseInt(product.QTE) -
        parseFloat(product.REMISE)
      ).toFixed(2),
      idColis: product.NO_COLIS,
      status: product.ETAT,
      gift: product.KDOS,
    }));
  }, [orderArticles]);

  const subTotalOrder = (
    parseFloat(order.MTT_TOTAL) -
    (parseFloat(order.FPORT) +
      parseFloat(order.FSIMO) +
      parseFloat(order.FCR) +
      parseFloat(order.FDOUA)) +
    parseFloat(order.REM)
  ).toFixed(2);

  let subTotalDiscount = 0;
  orderArticles.map(article => {
    subTotalDiscount = subTotalDiscount - parseFloat(article.REMISE);
  });

  const data: DataDetailledOrder = {
    idOrder: order.NUM_CDE || '',
    date: order.DATE_CDE || order.DATE_EVT || '',
    paymentMethod: order.MOD_PAI,
    deliveryMethod: order.MODE_LIVRAISON,
    products,
    subTotalOrder,
    subTotalDiscount: subTotalDiscount.toFixed(2),
    FPORT: order.FPORT,
    FSIMO: order.FSIMO,
    FCR: order.FCR,
    FDOUA: order.FDOUA,
    REM: order.REM,
    MTT_TOTAL: order.MTT_TOTAL,
  };

  return (
    <>
      {order && data && (
        <>
          <DetailsProducts order={data} />
          <DetailsProductsActions />
        </>
      )}
    </>
  );
}

export default OrderDetails;
